var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIslands = function SvgIslands(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1299 398.98C69.1699 398.98 69.1699 434.98 105.21 434.98C141.25 434.98 141.25 398.98 177.29 398.98C213.33 398.98 213.33 434.98 249.37 434.98C285.41 434.98 285.41 398.98 321.46 398.98C357.51 398.98 357.5 434.98 393.55 434.98C429.6 434.98 429.59 398.98 465.64 398.98",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.96 387.58C114.96 360.7 141.61 337.25 181.17 324.77C200.42 318.7 222.73 315.23 246.51 315.23C268.84 315.23 289.86 318.29 308.28 323.69C349.8 335.86 378.06 359.91 378.06 387.59",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204.23 118.9C190.02 112.34 98.27 63.9898 98.27 63.9898C103.96 61.0598 144.71 40.9398 189.42 60.1598C224.18 75.0898 239.26 104.31 243.04 112.24",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256.96 112.24C260.74 104.31 275.82 75.0898 310.58 60.1598C355.29 40.9398 396.05 61.0598 401.73 63.9898L358.84 86.1998L325.13 80.0698L335.09 100.75C323.99 105.87 312.89 111 301.79 116.12",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M259.57 112.62C260.24 112.54 261.05 112.45 261.99 112.37C263.53 112.23 265.43 112.09 267.63 112.01C275.77 111.71 288.04 112.2 301.79 116.12C311.48 118.87 321.92 123.34 332.17 130.44C372.17 158.15 376.74 203.37 377.27 209.74C377.27 209.74 340.64 191.37 272.38 147.55",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.87 137.1C246.6 138.58 244.33 140.07 242.06 141.55",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M214.51 117.32C211.28 117.66 207.83 118.16 204.23 118.9C192.39 121.28 178.88 126.05 165.68 135.2C125.68 162.91 121.12 208.13 120.58 214.5L162.16 189.92L174.85 158.1L187.1 177.51L231.95 148.17H231.97",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M217 315.22C213.82 291.14 211.95 258.41 217 220.24C219.79 199.09 224.21 180.07 229.2 163.45",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M232.84 152H232.85C233.38 150.41 233.91 148.87 234.45 147.35",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M254.25 144.5C254.18 144.94 254.12 145.37 254.07 145.81",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M251.39 180.99C251.18 193.12 251.69 206.27 253.29 220.24C258.04 261.69 270.54 294.19 280.57 315.22",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M265.96 148.71C276.111 148.71 284.34 140.481 284.34 130.33C284.34 120.179 276.111 111.95 265.96 111.95C255.809 111.95 247.58 120.179 247.58 130.33C247.58 140.481 255.809 148.71 265.96 148.71Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M227.51 148.71C237.661 148.71 245.89 140.481 245.89 130.33C245.89 120.179 237.661 111.95 227.51 111.95C217.359 111.95 209.13 120.179 209.13 130.33C209.13 140.481 217.359 148.71 227.51 148.71Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M247.57 181.39C257.721 181.39 265.95 173.161 265.95 163.01C265.95 152.859 257.721 144.63 247.57 144.63C237.419 144.63 229.19 152.859 229.19 163.01C229.19 173.161 237.419 181.39 247.57 181.39Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIslands);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/islands.svg";